import styled from 'styled-components';

export const Page = styled.div`
  background: linear-gradient(160deg, rgba(8,8,8,.98) 0%, rgba(12,18,32,.97) 50%, rgba(8,8,8,.98) 100%);
  background-color: #07101f;
  min-height: 100vh;
  color: #f8fafc;
  margin-top: -72px;
  padding-top: 72px;
  @media (max-width: 768px) { margin-top: -60px; padding-top: 60px; }
`;

export const Main = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.2rem 1rem 3rem;
`;

export const Header = styled.section`
  display: grid;
  gap: 0.65rem;
  margin-bottom: 1rem;
`;

export const Title = styled.h1`
  margin-bottom: 0;
`;

export const Subtitle = styled.p`
  color: #94a3b8;
  max-width: 760px;
`;

export const Nav = styled.section`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const NavButton = styled.button`
  background: #111827;
  color: #e2e8f0;
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  cursor: pointer;
`;

export const Section = styled.section`
  margin-bottom: 1.5rem;
`;
